var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 349.9 309.2",
    style: {
      enableBackground: "new 0 0 349.9 309.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.5,265.9c0-4.5-1.6-8.6-4.9-12.1c-3.3-3.5-7.2-5.1-11.8-4.9c-4.5,0.2-8.5,1.8-11.8,4.9 c-3.3,3.1-5,7.1-5.2,12.1c-0.2,4.9,1.5,8.8,5.2,11.8c3.7,3,7.5,4.6,11.8,4.9c4.3,0.3,8.2-1.4,11.8-4.9 C188.1,274,189.8,270.1,189.5,265.9z M138.9,198.2h50.6v-33.8h-20.8c-1.1,0-2,0.4-2.8,1.2l-25.8,25.8c-0.8,0.8-1.2,1.7-1.2,2.8 L138.9,198.2L138.9,198.2z M307.7,265.9c0-4.5-1.6-8.6-4.9-12.1c-3.3-3.5-7.2-5.1-11.8-4.9s-8.6,1.8-12.1,4.9 c-3.5,3.1-5.1,7.1-4.9,12.1c0.2,4.9,1.8,8.8,4.9,11.8c3.1,3,7.1,4.6,12.1,4.9s8.8-1.4,11.8-4.9 C305.7,274,307.4,270.1,307.7,265.9z M341.5,122.4v135c0,1.3-0.2,2.4-0.5,3.6c-0.3,1.1-1,1.9-1.9,2.4s-1.6,1-2.1,1.4 c-0.5,0.5-1.4,0.8-3.1,1c-1.5,0.2-2.6,0.2-3.1,0.2s-1.5,0-3.3,0c-1.7,0-2.7,0-2.8,0c0,9.3-3.3,17.3-10,23.9 c-6.6,6.6-14.6,10-23.9,10c-9.3,0-17.3-3.3-23.9-10c-6.6-6.6-10-14.6-10-23.9h-50.6c0,9.3-3.3,17.3-10,23.9 c-6.6,6.6-14.6,10-23.9,10s-17.3-3.3-23.9-10c-6.6-6.6-10-14.6-10-23.9h-8.5c-0.2,0-1.1,0-2.8,0s-2.9,0-3.6,0 c-0.7,0-1.5-0.1-2.8-0.2c-1.3-0.2-2.3-0.5-3.1-1c-0.8-0.5-1.4-1-2.1-1.4s-1.3-1.3-1.9-2.4c-0.7-1.1-0.8-2.3-0.5-3.6 c0-2.4,0.8-4.3,2.4-5.9c1.5-1.5,3.6-2.4,5.9-2.6v-42.1c0-0.8,0-2.4,0-4.7c0-2.4,0-4.1,0-4.9c0-1,0.2-2.4,0.5-4.4 c0.3-2,0.6-3.7,0.7-4.9c0.2-1.3,0.8-2.6,1.9-4.1c1.1-1.4,2.1-2.8,3.1-4.1l26.1-26c1.7-1.7,4-3.2,6.6-4.3c2.7-1.1,5.3-1.6,7.8-1.6 h21.1v-25.3c0-2.4,0.9-4.4,2.6-6.2s3.7-2.5,5.9-2.4h135c2.4,0,4.3,0.8,5.9,2.4C340.4,117.7,341.3,119.8,341.5,122.4L341.5,122.4z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48.6,
    y: 2,
    className: "st0",
    width: 31,
    height: 31
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.3,219.2H33V79.6h186.2v13.9h31.1v-76c-0.1-8.6-7-15.6-15.7-15.6h-15.6v46.6h-62.1V2H95v46.6H32.9V2H17.6 C8.9,2,2,8.9,2,17.6v217.2c0,8.6,6.9,15.6,15.6,15.6h77.7V219.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.6,
    y: 2,
    className: "st0",
    width: 31,
    height: 31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 157.2,
    className: "st0",
    width: 31,
    height: 31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.6,
    y: 110.7,
    className: "st0",
    width: 31,
    height: 31
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1,
    y: 110.7,
    className: "st0",
    width: 31,
    height: 31
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingBooking);
export default __webpack_public_path__ + "static/media/shipping_booking.5110c3cb152bb23e521ac2f7e4026810.svg";
export { ForwardRef as ReactComponent };